import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'

/**
 * Default columnn type for table grouping that makes sense
 */
export const DEFAULT_COLUMN_TYPES: ColumnTypes[] = [
  ColumnTypes.Text,
  ColumnTypes.Number,
  ColumnTypes.Email,
  ColumnTypes.Phone,
  ColumnTypes.Emoji,
  ColumnTypes.Icon,
  ColumnTypes.Color,
  ColumnTypes.Address,
  ColumnTypes.Number,
  ColumnTypes.Rating,
  ColumnTypes.Boolean,
  ColumnTypes.DateTime,
  ColumnTypes.MultiSelect,
  ColumnTypes.Coordinate,
  ColumnTypes.Function,
  ColumnTypes.Lookup,
  ColumnTypes.Formula,
  ColumnTypes.Join,
]

export const DEFAULT_IMAGE_TYPES = ['.webp', '.png', '.jpg', '.jpeg', '.gif']

export const ALLOWED_IMAGE_TYPES = [
  ...DEFAULT_IMAGE_TYPES,
  '.svg',
  '.bmp',
  '.tiff',
  '.ico',
  '.cur',
  '.heic',
  '.heif',
  '.avif',
]

export const DEFAULT_FILE_TYPES = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.txt', '.csv', '.zip']

export const ALLOWED_FILE_TYPES = [
  ...ALLOWED_IMAGE_TYPES,
  ...DEFAULT_FILE_TYPES,
  '.ppt',
  '.pptx',
  '.ods',
  '.psd',
  '.ai',
  '.stl',
  '.obj',
  '.mp3',
  '.mp4',
  '.wav',
  '.wmv',
  '.avi',
  '.mov',
  '.mpg',
  '.mpeg',
  '.m4a',
  '.m4v',
  '.ogg',
  '.webm',
  '.json',
  '.xml',
  '.ppt',
  '.pptx',
  '.ods',
  '.psd',
  '.ai',
  '.stl',
  '.obj',
  '.mp3',
  '.mp4',
  '.wav',
  '.wmv',
  '.avi',
  '.mov',
  '.mpg',
  '.mpeg',
  '.m4a',
  '.m4v',
  '.ogg',
  '.webm',
]

export const PAGINATION_CONSTANTS = {
  DEFAULT_PER_PAGE: 10,
  DEFAULT_PER_PAGE_OPTIONS: [
    { value: 5, label: '5' },
    { value: 10, label: '10' },
    { value: 25, label: '25' },
    { value: 50, label: '50' },
    { value: 100, label: '100' },
  ],
}

export const ALLOWED_PROMPT_TYPES = [...ALLOWED_IMAGE_TYPES, '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.txt', '.csv']

export const COLOR_TYPES = {
  ADAPTIVE: 'adaptive',
  SOLID: 'solid',
  GRADIENT: 'gradient',
} as const
